import { render, staticRenderFns } from "./koejakso-view-erikoistuva.vue?vue&type=template&id=8b315190&scoped=true&"
import script from "./koejakso-view-erikoistuva.vue?vue&type=script&lang=ts&"
export * from "./koejakso-view-erikoistuva.vue?vue&type=script&lang=ts&"
import style0 from "./koejakso-view-erikoistuva.vue?vue&type=style&index=0&id=8b315190&lang=scss&scoped=true&"
import style1 from "./koejakso-view-erikoistuva.vue?vue&type=style&index=1&id=8b315190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b315190",
  null
  
)

export default component.exports